var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.816,
    height: 23.816,
    viewBox: "0 0 23.816 23.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 11.534,
    height: 13.249,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(-1237 -435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1936",
    "data-name": "Trac\\xE9 1936",
    d: "M11.908,0A11.908,11.908,0,1,1,0,11.908,11.908,11.908,0,0,1,11.908,0Z",
    transform: "translate(1237 435)",
    fill: "#0898ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(1243.141 440.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1937",
    "data-name": "Trac\\xE9 1937",
    d: "M6.049,8.955l-.893.893,1.685,1.685a.632.632,0,0,0,.893,0l3.159-3.159L10,7.481,7.288,10.193Z",
    transform: "translate(-2.152 -3.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1938",
    "data-name": "Trac\\xE9 1938",
    d: "M6.049,8.955l-.893.893,1.685,1.685a.632.632,0,0,0,.893,0l3.159-3.159L10,7.481,7.288,10.193Z",
    transform: "translate(-2.152 -3.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1939",
    "data-name": "Trac\\xE9 1939",
    d: "M6.4.674,5.976.529,5.554.674,1.342,2.149l-.842.3V7.521a4.907,4.907,0,0,0,2.89,4.464l2.068.931.518.234.518-.234,2.068-.931a4.906,4.906,0,0,0,2.89-4.467V2.443l-.842-.3Zm3.791,6.845a3.635,3.635,0,0,1-2.144,3.315l-2.068.931-2.068-.931A3.635,3.635,0,0,1,1.764,7.519V3.341L5.976,1.866l4.212,1.474Z",
    transform: "translate(-0.209 -0.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1940",
    "data-name": "Trac\\xE9 1940",
    d: "M6.4.674,5.976.529,5.554.674,1.342,2.149l-.842.3V7.521a4.907,4.907,0,0,0,2.89,4.464l2.068.931.518.234.518-.234,2.068-.931a4.906,4.906,0,0,0,2.89-4.467V2.443l-.842-.3Zm3.791,6.845a3.635,3.635,0,0,1-2.144,3.315l-2.068.931-2.068-.931A3.635,3.635,0,0,1,1.764,7.519V3.341L5.976,1.866l4.212,1.474Z",
    transform: "translate(-0.209 -0.221)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.43e33ff40ffe0ff8663849f1ff862792.svg";
export { ForwardRef as ReactComponent };